import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import './CalendarFetchByWeek.scss';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export function getSundayGivenWeekDate(date = dayjs()): Dayjs {
  const dateToSet = dayjs(date);
  const sunday = dateToSet.clone().weekday(7);
  if (dateToSet.isoWeek() === sunday.isoWeek()) {
    return sunday;
  } else if (dateToSet.isoWeek() - sunday.isoWeek() === -1) {
    const sundayToReturn = dateToSet.clone().weekday(0);
    return sundayToReturn;
  } else {
    return sunday;
  }
}

export function getMondayGivenWeekDate(date = dayjs()): Dayjs {
  const dateToSet = dayjs(date);
  const monday = dateToSet.clone().weekday(1);
  if (dateToSet.isoWeek() === monday.isoWeek()) {
    return monday;
  } else if (dateToSet.isoWeek() - monday.isoWeek() === -1) {
    const mondayToReturn = dateToSet.set('day', -1).clone().weekday(1);
    return mondayToReturn;
  } else {
    return monday;
  }
}

export function CalendarFetchByWeek({
  fetchValues,
  givenStartDate = dayjs(new Date()),
  givenEndDate = dayjs(new Date()),
}: {
  fetchValues: (vals: { fetchStartDate: Dayjs; fetchEndDate: Dayjs }) => void;
  givenStartDate: Dayjs;
  givenEndDate: Dayjs;
}): JSX.Element {
  const [startDate, setStartDate] = useState<Dayjs>(dayjs(givenStartDate));
  const [endDate, setEndDate] = useState<Dayjs>(dayjs(givenEndDate));

  const changeWeek = (changeInt, endDate, startDate) => {
    const fetchStartDate = dayjs(startDate).add(changeInt > 0 ? 7 : -7, 'day');
    const fetchEndDate = dayjs(endDate).add(changeInt > 0 ? 7 : -7, 'day');
    setStartDate(fetchStartDate);
    setEndDate(fetchEndDate);
    fetchValues({ fetchStartDate, fetchEndDate });
  };

  const weekNumber = startDate.isoWeek();

  return (
    <div className="calendarfetchByWeek">
      <div className="calendarRow">
        <div className="choosePeriod">
          <div className="positionChooser">
            <FaChevronLeft onClick={() => changeWeek(-1, endDate, startDate)} />
            <div className="cal-week">Week {weekNumber}</div>
            <FaChevronRight onClick={() => changeWeek(1, endDate, startDate)} />
          </div>
        </div>
      </div>

      <div className="calendarRow">
        <div className="positionToFromDates">
          <div className="positionDate">
            <div className="text">
              {`${dayjs(startDate).format('DD. MMM YY')}`}
            </div>
          </div>

          <div className="positionDate">
            <div className="text">{'-'}</div>
            <div className="text">
              {`${dayjs(endDate).format('DD. MMM YY')}`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
